import React from 'react';
import { useSelector } from 'react-redux';
import { ExternalScripts } from 'mm-ui-components';
import { getExternalScripts } from '../../store/config/config.selectors';

export const HeadScripts: React.FunctionComponent = () => {
  const scripts = useSelector(getExternalScripts);
  return <ExternalScripts scripts={scripts} />;
};
